let _ = t => t,
  _t;
import styled from 'styled-components';
import { Box } from 'react-polymorphic-box';
import { defaultPx, asIs, toCss } from '../_internal/utils/styles';
export const propsMap = {
  $maxHeight: {
    name: 'max-height',
    apply: defaultPx
  },
  $minHeight: {
    name: 'min-height',
    apply: defaultPx
  },
  $maxWidth: {
    name: 'max-width',
    apply: defaultPx
  },
  $minWidth: {
    name: 'min-width',
    apply: defaultPx
  },
  m: {
    name: 'margin',
    apply: asIs
  },
  mb: {
    name: 'margin-bottom',
    apply: defaultPx
  },
  mt: {
    name: 'margin-top',
    apply: defaultPx
  },
  ml: {
    name: 'margin-left',
    apply: defaultPx
  },
  mr: {
    name: 'margin-right',
    apply: defaultPx
  },
  p: {
    name: 'padding',
    apply: asIs
  },
  pb: {
    name: 'padding-bottom',
    apply: defaultPx
  },
  pt: {
    name: 'padding-top',
    apply: defaultPx
  },
  pl: {
    name: 'padding-left',
    apply: defaultPx
  },
  pr: {
    name: 'padding-right',
    apply: defaultPx
  }
};
function selectDisplayStyle({
  $flex,
  $inline
}) {
  if ($flex) {
    return $inline ? 'inline-flex' : 'flex';
  }
  return $inline ? 'inline-block' : 'block';
}
function selectAlignmentStyle({
  $flex,
  $center
}) {
  if ($center) {
    return `${$flex ? 'align-items' : 'text-align'}: center;`;
  }
  return '';
}
export const StyledBox = styled(Box)(_t || (_t = _`
    display: ${0};
    flex-direction: ${0};

    width: ${0};

    ${0}
    ${0};
`), selectDisplayStyle, ({
  $flex,
  $column
}) => $flex && $column && 'column', ({
  $fullWidth
}) => $fullWidth ? '100%' : 'auto', selectAlignmentStyle, toCss(propsMap));